import { isSameMonth } from '../utils/isSameMonth'

export function isSameDate(date, comparison) {
    return isSameMonth(date, comparison) && date.getDate() === comparison.getDate()
}